import { render, staticRenderFns } from "./Atlas.vue?vue&type=template&id=150214a8"
import script from "./Atlas.vue?vue&type=script&lang=js"
export * from "./Atlas.vue?vue&type=script&lang=js"
import style0 from "./Atlas.vue?vue&type=style&index=0&id=150214a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports